module.exports = __webpack_public_path__ + "static/CCQ_CorredorNorte-f0d1edaed9e72bd24af102fa369f34d1.png";